import FooterPatient from '../components/footer'

export default {
  FooterPatient
}



// WEBPACK FOOTER //
// ./src/app/profile-public/professional/resources/components.js